import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { useNavigate, Link } from "react-router-dom";
import $ from "jquery";
import CallAPI from "../../services/apiCalls";
import DetailsOrgEmails from "./DetailsOrgEmails";
import UserEmailList from "../users/UserEmailList";
import { Dropdown } from "primereact/dropdown";
import { MdnDispatchMode } from "../../utils/enums";
import ConfirmActionModal, {
  ActionType,
  ActionStatusDisplay,
} from "../shared/ConfirmActionModal";
import useDragScroll from "../../hooks/useDragScroll";

let o = {
  OrganizationId: "",
  Email: "",
  SearchBy: "",
  FromDate: "",
  ToDate: "",
  UserName: "",
  Name: "",
};

const ListEmails = () => {
  const {
    userRole,
    userToken,
    SetSharedObject,
    sharedObject,
    XdrArr,
    setXDRArr,
    userSession,
    backendTarget,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    XdrArr: state.XdrArr,
    setXDRArr: state.setXDRArr,
    userSession: state.userSession,
    backendTarget: state.backendTarget,
  }));
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const [emailListObj, setEmailListObj] = useState([]);
  const [showGridFlag, SetShowGridFlag] = useState(false);
  const navigate = useNavigate();
  const [addBtnFlag, setAddBtnFlag] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [customerCustVal, setCustomerCustVal] = useState(null);
  const [orgObj, SetOrgObj] = useState([]);
  const [customerOrgVal, setCustomerOrgVal] = useState(null);
  const [customerObj, SetCustomerObj] = useState([]);
  const [customerCustValSearch, setCustomerCustValSearch] = useState(null);
  const [orgObjSearch, SetOrgObjSearch] = useState([]);
  const [customerOrgValSearch, setCustomerOrgValSearch] = useState(false);
  const [customerObjSearch, SetCustomerObjSearch] = useState([]);
  const [answers, setAnswers] = useState(o);
  const [detailsEmail, setdetailsEmail] = useState({});
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [custFlag, SetCustFlag] = useState(false);
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");
  const [orgId, setOrgId] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [actionProcessing, setActionProcessing] = useState(false);
  const [actionSuccessFlag, setActionSuccessFlag] = useState(false);
  const [actionErrorMessage, setActionErrorMessage] = useState("");
  const [actionResults, setActionResults] = useState(null);
  const actionMenuRef = useRef(null);
  const tableContainerRef = useRef(null);
  useDragScroll(tableContainerRef, [sharedObject.emailListObj]);
  const setAnswer = (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };

  const getXDREndPoints = async () => {
    setProcessing(true);
    SetErrDetailFlag(false);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const getOrgIdEmailsList = async (mdl) => {
    setProcessing(true);
    SetErrDetailFlag(false);
    let call = "";
    if (mdl.Flag === "orgEmails") {
      call = "/organization/GetDirectEmails?orgId=" + mdl.Id;
    } else {
      call = "/emails/GetUsersDirectEmails?userId=" + mdl.Id;
    }
    const res = await CallAPI(call, false, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      setProcessing(false);
      setAddBtnFlag(true);
      let tempObj = [];
      for (const row of res.data.data) {
        row.CustomerId = customerCustVal;
        row.FlagType = "emailLIst";
        row.organizationId = mdl.Id;

        if (mdl.Flag === "orgEmails") {
          row.id = row.directEmailId;
          row.emailType = "orgEmails";
          row.userId = 0;
        } else {
          row.emailType = "userEmails";
        }

        let cs = (
          <button
           type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailType(row, "show");
              el.preventDefault();
            }}
            aria-label={`View details for ${row.directEmailAddress || "this email"}`}
          >
            {row.directEmailAddress}
          </button>
        );
        row.dtCreated = new Date(row.dateCreated);
        row.date = new Date(row.dateCreated);
        row.dtModified = row.dateModified ? new Date(row.dateModified) : null;
        row.GridLinkCourse = cs;
        row.keepMdn = row.keepMDN ? "YES" : "NO";
        row.directEmailPurpose =
          row.directEmailPurposeId === 0 || row.emailPurposeId === 0
            ? "General"
            : row.directEmailPurposeId === 1 || row.emailPurposeId === 1
              ? "Medical RecordsXML only"
              : row.directEmailPurposeId === 2 || row.emailPurposeId === 2
                ? "Medical Records"
                : "Administrative";
        let es = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailTypeName(row, "show");
              el.preventDefault();
            }}
            aria-label={`View details for emails ${row.name || "this email"}`}
          >
            {row.name}
          </button>
        );
        row.EmailDirect = es;
        row.name = mdl.Name;

        if (row.userEmailTypeString !== "Shared") {
          tempObj.push(row);
        }
      }

      if (tempObj.length > 0) {
        CloseAdvSearch();
      }

      SetSharedObject("emailListObj", tempObj);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  useEffect(() => {
    setAddBtnFlag(false);
    SetSharedObject("emailsSharing", []);
    SetCustomerObj(sharedObject.vendorsObj);

    const temp = [];
    if (sharedObject?.vendorsObj?.length > 0) {
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        temp.push(el);
      }
    }

    SetCustomerObjSearch(temp);
    let obj = sharedObject.UserIdEmail;

    if (Object.keys(obj).length > 0 && obj.constructor === Object) {
      setAddBtnFlag(true);
      SetShowGridFlag(true);
      SetCustFlag(true);
      getOrgIdEmailsList(obj);
    }

    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      OrgSearchEngine(userSession.vendor_id);
      SetSharedObject("reloadEmailList", false);
    }

    getXDREndPoints();
  }, [sharedObject.reloadEmailList]);

  const OrgSearchEngine = async (id) => {
    let obj = { VendorId: id };
    setProcessing(true);

    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, obj, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      const temp = [];
      for (let el of dt) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObjSearch(temp);
      SetOrgObj(temp);
      setProcessing(false);
    }
  };

  const GetXdrConfig = async (vl) => {
    let tempXDR = {};
    if (vl) {
      for (let el of XdrArr) {
        if (el.id === parseInt(vl)) {
          tempXDR = el;
          break;
        }
      }
    }

    SetSharedObject("orgXDRObj", tempXDR);
    SetSharedObject("xdrSettiingObj", tempXDR);
  };

  const getEmailsList = async (mdl, check, userEmails) => {
    setProcessing(true);
    SetErrDetailFlag(false);
    if (check) {
      await getOrgDetails(mdl.OrganizationId);
    }

    let call = "";
    let obj = null;

    if (userEmails) {
      call = "/emails/GetUserEmails?SesUserId=" + parseInt(mdl.UserId);
      obj = false;
    } else {
      obj = mdl;
      call = "/emails/SearchEmails";
    }
    const res = await CallAPI(call, obj, "post", userToken);
    SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      let tempObj = [];

      for (const row of res.data.data) {
        row.CustomerId = customerCustVal;
        row.FlagType = "orgLIst";
        let cs = (
            <button 
            type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailType(row, "show");
              el.preventDefault();
            }}
            aria-label={`View details for ${row.directEmailAddress || "this email"}`}
          >
            {row.directEmailAddress}
          </button>
        );

        row.dtCreated = new Date(row.dateCreated);
        row.GridLinkCourse = cs;
        row.date = new Date(row.dateCreated);
        row.dtModified = row.dateModified ? new Date(row.dateModified) : null;
        row.keepMdn = row.isKeepMDN ? "YES" : "NO";
        // EmailSearchResultResponse names these fields "active"/"publishable";
        // StatusDisplay/PublishableDisplay (and the activate/deactivate/publish
        // confirm-modal checks) read "isEnabled"/"isPublished", so map them here.
        row.isEnabled = row.active;
        row.isPublished = row.publishable;
        row.directEmailPurpose =
          row.directEmailPurposeId === 0
            ? "General"
            : row.directEmailPurposeId === 1
              ? "Medical RecordsXML only"
              : row.directEmailPurposeId === 2
                ? "Medical Records"
                : "Administrative";
        let es = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailTypeName(row, "show");
              el.preventDefault();
            }}
            aria-label={
              row.emailType === "Organization"
                ? `Go to organization: ${row.name}`
                : `Go to user: ${row.name}`
            }
          >
            {row.name}
          </button>
        );
        row.userEmailTypeString = row.emailType;
        row.EmailDirect = es;
        tempObj.push(row);
      }

      if (tempObj.length > 0) {
        CloseAdvSearch();
        SetShowGridFlag(true);
      }
      SetSharedObject("emailListObj", tempObj);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
  };

  const getOrgDetails = async (id) => {
    SetSharedObject("orgXDRObj", {});
    SetSharedObject("orgDetails", {});
    setProcessing(true);

    let call = "/emails/GetOrgDetails?OrganizationId=" + parseInt(id);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      GetXdrConfig(res.data.data.xdrConfig.id);
      SetSharedObject("orgDetails", res.data.data);
      SetSharedObject("orgActionObj", res.data.data);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";

      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }

    setProcessing(false);
  };

  const emailType = async (row) => {
    setSelectedProducts([row]);
    setProcessing(true);
    SetErrDetailFlag(false);
    setdetailsEmail({
      ...row,
      orgXDR: sharedObject.orgXDRObj,
      orgDetails: sharedObject.orgDetails,
    });

    if (row.emailType === "User" || row.emailType === "userEmails") {
      let call =
        "/emails/GetUserDirectEmails?directEmailId=" +
        parseInt(row.directEmailId) +
        "&UserId=" +
        row.userId;

      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        SetSharedObject("emailsForwarding", res.data.data.emailForwards);
        await setdetailsEmail({
          ...row,
          emailForwording: res.data.data.emailForwards,
        });
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrDetailsMsg(str);
        SetErrDetailFlag(true);
      }
    } else {
      let call =
        "/emails/GetUserSharedEmails?DirectEmail=" + row.directEmailAddress;

      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        SetSharedObject("emailsSharing", res.data.data);
        setdetailsEmail({
          ...row,
          emailSharing: res.data.data,
        });
      } else if (res.status === "SERVERERROR") {
        SetErrDetailsMsg(
          "An error occurred. Please contact your administrator",
        );
        SetErrDetailFlag(true);
      }
    }

    setProcessing(false);
    $("#detailsEmailOrgModal").modal("show");
  };

  const emailTypeName = async (row) => {
    if (row.emailType === "Organization") {
      navigate("/organizations");
    } else {
      setProcessing(false);
      navigate("/users");
    }
  };

  const CustomerIdSet = async (el) => {
    setCustomerCustVal(el);

    if (el === "") {
      SetOrgObj([]);
      return;
    }

    customerObjSearch.map((elx) => {
      if (elx.id === parseInt(el))
        SetSharedObject("CustomerPermissionsObj", elx);
    });

    setAddBtnFlag(false);
    SetShowGridFlag(false);
    let obj = sharedObject.getOrgsObj;
    let temp = [];
    if (obj) {
      for (let elem of obj) {
        if (parseInt(el) === elem.vendorId) {
          temp.push(elem);
        }
      }
    }
    SetOrgObj(temp);
  };

  const CustomerIdSetSearch = async (el) => {
    setCustomerCustValSearch(el);

    if (el === "") {
      SetOrgObjSearch([]);
      return;
    }

    customerObjSearch.map((elx) => {
      if (elx.id === parseInt(el))
        SetSharedObject("CustomerPermissionsObj", elx);
    });

    setProcessing(true);

    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObjSearch(temp);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const SelectUsersByOrgId = async (vl) => {
    SetSharedObject("orgDetails", {});
    SetSharedObject("UserIdEmail", {});
    setCustomerOrgVal(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setOrgId(orgId);
    SetShowGridFlag(true);
    let src = {};
    src.OrganizationId = parseInt(orgId);
    getEmailsList(src, true);
  };

  const [orgIdSearch, setOrgIdSearch] = useState(false);

  const SelectUsersByOrgIdSearch = async (vl) => {
    SetCustFlag(false);
    SetShowBackBtn(false);
    setCustomerOrgValSearch(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setOrgIdSearch(orgId);
    setAnswer("OrganizationId", orgId);
  };

  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchByEmail();
    }
  };

  const SearchByEmail = async () => {
    SetCustFlag(false);
    SetShowBackBtn(false);
    if (searchEmail === "") {
      return;
    }
    let src = {};
    //src.OrganizationId = orgId;
    src.Email = searchEmail;
    getEmailsList(src, false);
  };

  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      customerObjSearch?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      customerObjSearch?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustomerObjSearch(tmp);
  };

  const filterOrgs = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObjSearch?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObjSearch?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObjSearch(tmp);
  };

  const handleDateChange = (field, val) => {
  // If val is an object (datepicker Date object), convert it to a locale string.
  // If it's already a string or empty, use it directly.
  const cleaned =
    val && typeof val === "object"
      ? val.toLocaleDateString("en-US")
      : val ?? "";
  setAnswer(field, cleaned);
};

  const AdvSearch = () => {
    setSubmitFlag(true);
    SetCustFlag(false);
    SetShowBackBtn(false);
    if (answers.OrganizationId === "") return;
    SetShowGridFlag(true);
    const payload = {
    ...answers,
    // Send null instead of empty string so the API ignores the field
    FromDate: answers.FromDate || null,
    ToDate: answers.ToDate || null,
  };

  getEmailsList(payload, true);
  };

  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "orgEmails") {
        navigate("/organizations");
      } else if (sharedObject.UserIdEmail.Navigate === "Users") {
        navigate("/users");
      }
    }
  };

  const emailRefresh = (detailsEmail) => {
    let src = {};
    src.OrganizationId = parseInt(detailsEmail.organizationId, false);
    if (detailsEmail.FlagType === "orgLIst") {
      getEmailsList(src, true);
    } else {
      getOrgIdEmailsList(detailsEmail, true);
    }
  };

  const openActionConfirm = (action) => {
    setSelectedAction(action);
    setActionErrorMessage("");
    setActionSuccessFlag(false);
    setActionResults(null);
    $("#ConfirmAction").modal("show");
  };

  const handleActionConfirm = async (reason) => {
    if (selectedProducts.length === 0) {
      setActionErrorMessage("Please select an email.");
      return;
    }

    if (selectedAction === ActionType.DELETE) {
      await DeleteEmails(reason);
      return;
    }

    if (selectedAction === ActionType.ACTIVATE) {
      await SubmitEmailStatusAction("/emails/activate", "activationResults", true);
      return;
    }

    if (selectedAction === ActionType.DEACTIVATE) {
      await SubmitEmailStatusAction("/emails/deactivate", "deactivationResults", false);
      return;
    }

    if (selectedAction === ActionType.PUBLISH) {
      await SubmitPublishAction("/emails/publish", true);
      return;
    }

    if (selectedAction === ActionType.UNPUBLISH) {
      await SubmitPublishAction("/emails/unpublish", false);
      return;
    }
  };

  
  const SubmitEmailStatusAction = async (call, resultsKey, newIsEnabled) => {
    setActionErrorMessage("");
    setActionProcessing(true);
    setActionSuccessFlag(false);
    setActionResults(null);

    const addresses = selectedProducts.map((el) => el.directEmailAddress);
    const payload = { addresses };

    // CPPCON-1481: activate/deactivate moved from PATCH to POST (AWS Load
    // Balancer doesn't support PATCH) - confirmed on develop 2026-08-21.
    const res = await CallAPI(call, payload, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      const results = res.data.data[resultsKey] ?? {};
      setActionResults(results);
      setActionSuccessFlag(true);

      // Reflect the new status (and who/when changed it) in the grid right
      // away, for every address the API actually found - addresses it
      // reported as "not found" are left as-is since nothing changed for
      // them.
      const updatedAddresses = new Set(
        Object.entries(results)
          .filter(([, message]) => !/not found/i.test(message))
          .map(([address]) => address)
      );
      if (updatedAddresses.size > 0) {
        const now = new Date();
        for (const row of sharedObject.emailListObj) {
          if (updatedAddresses.has(row.directEmailAddress)) {
            row.isEnabled = newIsEnabled;
            row.modifiedBy = userSession.preferred_username;
            row.dtModified = now;
          }
        }
        SetSharedObject("emailListObj", [...sharedObject.emailListObj]);
      }
    } else {
      let msg = res.data;
      let str = "<div>";
      if (!msg) {
        str += `System Error. Please contact your Administrator.`;
      } else if (Array.isArray(msg)) {
        for (let el of msg) {
          str += `${el}`;
        }
      } else if (typeof msg === "object") {
        // From MedAllies - Validation errors come back as a field -> messages map,
        // e.g. { addresses: ["size must be between 1 and 50"] }.
        for (const fieldErrors of Object.values(msg)) {
          for (let el of [].concat(fieldErrors)) {
            str += `${el}`;
          }
        }
      } else {
        str += `${msg}`;
      }
      str += "</div>";
      setActionErrorMessage(str);
    }

    setActionProcessing(false);
  };

  // Publish/Unpublish (CPPCON-1379, Vincent's direct-portal-api). As of his
  // 2026-08-21 update these take the same { addresses } POST shape as
  // activate/deactivate and return a real per-address result - but the value
  // is a boolean (true = applied), not a descriptive string, and `false`
  // collapses "not found", "already in that state", and "org disables
  // directory sharing" into one signal with no way to tell which applies.
  const SubmitPublishAction = async (call, publishFlag) => {
    setActionErrorMessage("");
    setActionProcessing(true);
    setActionSuccessFlag(false);
    setActionResults(null);

    const addresses = selectedProducts.map((el) => el.directEmailAddress);
    const payload = { addresses };

    const res = await CallAPI(call, payload, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      const actionResults = res.data.data.actionResults ?? {};
      const successVerb = publishFlag
        ? "Published successfully"
        : "Unpublished successfully";
      const results = {};
      for (const [address, applied] of Object.entries(actionResults)) {
        results[address] = applied ? successVerb : "No change made";
      }
      setActionResults(results);
      setActionSuccessFlag(true);

      // Reflect the new Publishable status locally for every address the API
      // actually applied. Unlike activate/deactivate, publishDirectEmails
      // doesn't stamp modifiedBy/dateModified, so we don't fake those here.
      const updatedAddresses = new Set(
        Object.entries(actionResults)
          .filter(([, applied]) => applied)
          .map(([address]) => address)
      );
      if (updatedAddresses.size > 0) {
        for (const row of sharedObject.emailListObj) {
          if (updatedAddresses.has(row.directEmailAddress)) {
            row.isPublished = publishFlag;
          }
        }
        SetSharedObject("emailListObj", [...sharedObject.emailListObj]);
      }
    } else {
      let msg = res.data;
      let str = "<div>";
      if (!msg) {
        str += `System Error. Please contact your Administrator.`;
      } else if (Array.isArray(msg)) {
        for (let el of msg) {
          str += `${el}`;
        }
      } else if (typeof msg === "object") {
        for (const fieldErrors of Object.values(msg)) {
          for (let el of [].concat(fieldErrors)) {
            str += `${el}`;
          }
        }
      } else {
        str += `${msg}`;
      }
      str += "</div>";
      setActionErrorMessage(str);
    }

    setActionProcessing(false);
  };

  const DeleteEmails = async (reason) => {
    setActionErrorMessage("");
    setActionProcessing(true);
    setActionSuccessFlag(false);
    let hadError = false;

    for (const el of selectedProducts) {
      let orgId = el.organizationId ? el.organizationId : 0;
      let call =
        "/emails/DeleteUserDirectEmail?emailType=" +
        el.userEmailTypeString +
        "&directEmailId=" +
        el.directEmailId +
        "&userId=" +
        el.userId +
        "&directEmailAddress=" +
        el.directEmailAddress +
        "&orgId=" +
        orgId +
        "&reason=" +
        reason;

      const res = await CallAPI(call, false, "post", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        if (res.data.data?.errorList?.messages?.length > 0) {
          let msg = res.data.data.errorList?.messages;
          let str = "<div>";
          for (let el of msg) {
            str += `${el}`;
          }
          str += "</div>";
          setActionErrorMessage(str);
          hadError = true;
        } else {
          setSelectedProducts([]);
        }
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        if (msg === "") {
          str += `System Error. Please contact your Administrator.`;
        } else {
          for (let el of msg) {
            str += `${el}`;
          }
        }
        str += "</div>";
        setActionErrorMessage(str);
        hadError = true;
      }
    }

    if (!hadError) {
      setActionSuccessFlag(true);
      if (custFlag) {
        let obj = sharedObject.UserIdEmail;
        getOrgIdEmailsList(obj, true, true);
      } else {
        let src = {};
        src.OrganizationId = parseInt(orgId);
        getEmailsList(src, false);
      }
    }

    setActionProcessing(false);
  };

  const createdDate = (dt) => {
    return dt.dateCreated
      ? new Date(dt.dateCreated).toLocaleString("en-US", { hour12: false })
      : null;
  };

  const modifiedDate = (dt) => {
    return dt.dtModified
      ? new Date(dt.dtModified).toLocaleString("en-US", { hour12: false })
      : null;
  };

  const ModifiedByDisplay = (dt) => dt.modifiedBy?.split("|")[0] ?? "";

  const ServDesc = (dt) => {
    let val = dt.directTrustServiceDescriptionCode;
    const obj = sharedObject?.getServDesc;
    let servDesc = "";
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].code === val) {
        return obj[i].display;
      }
    }
    return servDesc;
  };
  const MdnDispatchModeDisplay = (dt) => {
    switch (dt.mdnDispatchMode) {
      case MdnDispatchMode.Conditional:
        return "Conditional";
      case MdnDispatchMode.AlwaysSend:
        return "Always Send";
      default:
        return "";
    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);


  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $(`#${modalId}`).modal("hide");

  };

  const CloseAdvSearch = () => closeModal("advEmailSearchModal");
  const CloseActionModal = () => {
    setActionSuccessFlag(false);
    setActionErrorMessage("");
    setSelectedAction(null);
    setActionResults(null);
  };

  const actionMenuItems = [
    {
      label: "Activate",
      icon: "bi bi-check-circle",
      command: () => openActionConfirm(ActionType.ACTIVATE),
    },
    {
      label: "Deactivate",
      icon: "bi bi-slash-circle",
      command: () => openActionConfirm(ActionType.DEACTIVATE),
    },
    {
      label: "Publish",
      icon: "bi bi-cloud-upload",
      command: () => openActionConfirm(ActionType.PUBLISH),
    },
    {
      label: "Unpublish",
      icon: "bi bi-cloud-slash",
      command: () => openActionConfirm(ActionType.UNPUBLISH),
    },
    {
      label: "Delete",
      icon: "bi bi-trash",
      command: () => openActionConfirm(ActionType.DELETE),
    },
  ];

  // Mirrors CertificateAuth's authorization check: an address is only
  // considered inactive once IsEnabled has explicitly been set to false;
  // legacy addresses that have never been activated/deactivated (isEnabled
  // is null) are treated as active.
  const StatusDisplay = (dt) =>
    dt.isEnabled === false
      ? ActionStatusDisplay[ActionType.DEACTIVATE]
      : ActionStatusDisplay[ActionType.ACTIVATE];

  // SubmitPublishAction sets row.isPublished locally right after a successful
  // Publish/Unpublish for immediate feedback; getEmailsList maps the real
  // value back from EmailSearchResultResponse.publishable on the next
  // refresh/re-search.
  const PublishableDisplay = (dt) => (dt.isPublished ? "True" : "False");

  // Flags, in the confirmation modal's item list, when a selected item is
  // already in the state the chosen action would put it in.
  const actionConfirmItemNote = (item) => {
    if (selectedAction === ActionType.ACTIVATE && item.isEnabled !== false) {
      return `already ${ActionStatusDisplay[ActionType.ACTIVATE]}`;
    }
    if (selectedAction === ActionType.DEACTIVATE && item.isEnabled === false) {
      return `already ${ActionStatusDisplay[ActionType.DEACTIVATE]}`;
    }
    return null;
  };

  return (
    <main className="ListEmails" >
      <div className="HeaderEmailTools">
        <header className="ht-6">
          <div className="spacer-inline sp-margin12">
            {showBackBtn ||
            (custFlag &&
              sharedObject.UserIdEmail.Navigate &&
              sharedObject.UserIdEmail.Navigate !== "detailUser") ? (
              <div className="spacer-inline btnback-container-1">
                <button className="btn btn-outline-secondary btnback sp-pad0"
                aria-label="Go back to previous page"
                  onClick={(el) => {
                    showParent(custFlag);
                    el.preventDefault();
                  }}
                >
                  <i className="bi bi-arrow-left-square-fill" aria-hidden="true"></i>
                </button>
              </div>
            ) : null}
            <h4 className="title-label3">
              {sharedObject.UserIdEmail?.Navigate === "orgEmails"
                ? `Emails for Org: ${sharedObject.UserIdEmail.Name}`
                : sharedObject.UserIdEmail?.Navigate === "detailUser"
                  ? `Emails for User: ${sharedObject.UserIdEmail.Name}`
                  : "List"}
            </h4>
          </div>

          <div className="mid-header-bar">
          {/*Search by name*/}
            <div className="spacer-inline spacer-margin5">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  id="searchByEmail"
                  name="searchByEmail"
                  placeholder="Search by Email"
                  autoComplete="off"
                  aria-label="Enter Email"
                  aria-describedby="searchByEmail"
                  onChange={(el) => setSearchEmail(el.target.value)}
                  value={searchEmail}
                  onKeyDown={SearchWithEnter}
                />
                <span id="searchByEmailHint" className="sr-only">
                  Type a direct email address and press Enter or click the search button.
                </span>
                <div className="input-group-append">
                  <button
                    className="input-group-text btn btn-secondary"
                    aria-label="Search by Email"
                    id="basic-addon2"
                    onClick={(e) => SearchByEmail()}
                  >
                    <i className="bi bi-search" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="OrgDropdown spacer-inline">
              <div role="toolbar" aria-label="Email list actions and filter options">
                {addBtnFlag && sharedObject.UserIdEmail.Name ? (
                  <button
                    className="btn btn-primary spacer-margin5"
                    aria-label={`Add email for ${sharedObject.UserIdEmail.Name || "this user"}`}
                    onClick={(el) => {
                      let o = {
                        id: sharedObject.UserIdEmail.Id,
                        name: sharedObject.UserIdEmail.Name,
                        domainName: sharedObject.UserIdEmail.Domain,
                        accountName: sharedObject.UserIdEmail.UserName,
                        firstName: sharedObject.UserIdEmail.FirstName,
                        userName: sharedObject.UserIdEmail.UserName,
                        lastName: sharedObject.UserIdEmail.LastName,
                        Flag: sharedObject.UserIdEmail.Flag,
                      };
                      if (sharedObject.UserIdEmail?.Flag === "orgEmails") {
                        SetSharedObject("orgActionObj", o);
                        $("#AddOrgEmailModal").modal("show");
                      } else if (
                        sharedObject.UserIdEmail?.Flag === "detailUser"
                      ) {
                        setEmailListObj(o);
                        $("#UsrEmailList").modal("show");
                      }
                    }}
                    data-toggle="modal"
                  >
                    Add
                  </button>
                ) : null}
                {userRole !== "SES ADMINISTRATOR" &&
                userRole !== "SYSTEMADMINISTRATOR" ? null : (
                  <Dropdown
                    value={selectedCustomer}
                    onChange={(e) => {
                      setSelectedCustomer(e.value);
                      CustomerIdSet(e.value?.id);
                    }}
                    options={customerObj}
                    optionLabel="name"
                    placeholder="Customers"
                    filter
                    className="form-control w-md2 spacer-margin5"
                    ariaLabel="Select customer"
                  />
                )}

                <Dropdown
                  value={customerOrgVal}
                  onChange={(e) => {
                    const selectedValue = e.value;
                    if (selectedValue) {
                      SelectUsersByOrgId(selectedValue); // or use id only, if needed
                    }
                  }}
                  options={orgObj.map((el) => ({
                    label: el.name,
                    value: `${el.id},${el.name}`,
                  }))}
                  placeholder="Organizations"
                  filter
                  className="form-control w-md2 spacer-margin5"
                  ariaLabel="Select organization"
                />
              </div>
            </div>

            {/* Advanced Search*/}
            <div className="spacer-inline">
              <button
                className="btn btn-primary ht-2"
                data-target="#advEmailSearchModal"
                data-toggle="modal"
                aria-haspopup="true"
                aria-expanded="false"
                aria-label="Open advanced search dialog"
              >
                Advanced Search
              </button>
            </div>
          </div>
        </header>
      </div>
      <section className="sp-margin1">
        {errDetailFlag ? (
          <div
            className={`alert alert-danger`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            dangerouslySetInnerHTML={{ __html: errDetailMsg }}
          />
        ) : null}
      </section>
      {showGridFlag ? (
        <section className="grid-layout">
          <div ref={tableContainerRef} className="drag-scroll-table">
            <DataTable
              value={sharedObject.emailListObj}
              aria-label="Email List"
              paginator
              selectionPageOnly
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              dataKey="id"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              columnResizeMode="expand"
              resizableColumns
              selectionMode={"checkbox"}
              selection={selectedProducts}
              onSelectionChange={(e) => {
                setSelectedProducts(e.value);
              }}
              selectionAutoFocus={false}
              sortField="dtCreated"
              sortOrder={-1}
            >
              <Column selectionMode="multiple" className="w-s"></Column>
              <Column
                field="GridLinkCourse"
                header="Direct Email"
                sortable
              ></Column>
              {sharedObject.UserIdEmail?.Flag === "orgEmails" ||
              sharedObject.UserIdEmail?.Flag === "detailUser" ? null : (
                <Column
                  field="emailType"
                  header="Type"
                  className="w-md3"
                  sortable
                ></Column>
              )}
              {isGcpUser && (
                <Column
                  field="isEnabled"
                  header="Status"
                  className="w-md3"
                  body={StatusDisplay}
                  sortable
                ></Column>
              )}
              <Column
                field="dtCreated"
                header="Date Created"
                className="w-md8"
                body={createdDate}
                sortable
              ></Column>
              <Column field="name" header="Name" sortable></Column>
              <Column
                field="directEmailPurpose"
                header="Purpose"
                className="w-md7"
                sortable
              ></Column>
              <Column
                field="keepMdn"
                header="Keep MDN"
                className="w-md1"
                sortable
              ></Column>
              <Column
                header="Send Dispatched MDN"
                body={MdnDispatchModeDisplay}
                sortable
              ></Column>
              <Column
                field="directTrustServiceDescriptionCode"
                header="Service Description"
                body={ServDesc}
                sortable
              ></Column>
              {isGcpUser && (
                <Column
                  field="isPublished"
                  header="Publishable"
                  className="w-md3"
                  body={PublishableDisplay}
                  sortable
                ></Column>
              )}
              <Column
                field="modifiedBy"
                header="Modified By"
                className="w-md3"
                body={ModifiedByDisplay}
                sortable
              ></Column>
              <Column
                field="dtModified"
                header="Last Modified"
                className="w-md8"
                body={modifiedDate}
                sortable
              ></Column>
            </DataTable>
          </div>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              {isGcpUser &&
              (userRole === "SES ADMINISTRATOR" ||
                userRole === "SYSTEMADMINISTRATOR") ? (
                <>
                  <Menu
                    model={actionMenuItems}
                    popup
                    ref={actionMenuRef}
                    id="emailActionsMenu"
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    aria-haspopup="true"
                    aria-controls="emailActionsMenu"
                    aria-label="Email record actions"
                    onClick={(e) => actionMenuRef.current?.toggle(e)}
                  >
                    Actions <i className="bi bi-caret-down-fill sp-margin3" aria-hidden="true"></i>
                  </button>
                </>
              ) : (
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => openActionConfirm(ActionType.DELETE)}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
          {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="grid-loader-id"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="grid-loader-id">{loadingText}</div>
            </div>
          )}
        </section>
      ) : (
        <section className="empty-grid" role="alert" aria-live="polite" aria-atomic="true">
          There are currently no results.
        </section>
      )}

      <ConfirmActionModal
        modalId="ConfirmAction"
        action={selectedAction}
        items={selectedProducts}
        itemLabel={(el) => el.directEmailAddress}
        itemKey={(el) => el.id}
        itemNote={actionConfirmItemNote}
        processing={actionProcessing}
        successFlag={actionSuccessFlag}
        errorMessage={actionErrorMessage}
        results={actionResults}
        onConfirm={handleActionConfirm}
        onClose={CloseActionModal}
      />
      <div className="SearchEmails">
        <div
          className="modal fade"
          id="advEmailSearchModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="advEmailSearchModalTitle"
          aria-describedby="advEmailSearchModalDesc"
          aria-modal="true"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-dialog-slideout">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title spacer-inline" id="advEmailSearchModalTitle">
                  Advanced Search
                </h2>
                <button
                  type="button"
                  className="close"
                  aria-label="Close Advanced Email Search"
                  onClick={CloseAdvSearch}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form aria-label="Advanced Email Search Form">
                <div className="modal-body" >
                    <p id="advEmailSearchModalDesc" className="sr-only">
                      Use this form to search emails by customer, organization, date range, or name.
                    </p>
                  <div className="modal-content-body container">
                    {/*Customers SES Admins only*/}
                    {userRole !== "SES ADMINISTRATOR" &&
                    userRole !== "SYSTEMADMINISTRATOR" ? null : (
                      <div className="field-wrapper">
                        <label htmlFor="customer" className="sp-margin3">
                          Customer
                        </label>
                        <span className="filter-container dg-clr">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            id="customerFilter"
                            name="CustomerFilter"
                            aria-label="Filter Customers"
                            onChange={(el) => {
                              filterVendors(el.target.value);
                            }}
                          />
                        </span>
                        <select
                          className="form-control"
                          size="4"
                          id="customer"
                          name="Customer"
                          aria-label="Select Customer"
                          onChange={(el) => {
                            CustomerIdSetSearch(el.target.value);
                          }}
                          value={customerCustValSearch}
                        >
                          <option value="">Select Customer</option>
                          {customerObjSearch?.map((el) => {
                            if (el.show)
                              return (
                                <option key={el.id} value={el.id}>
                                  {el.name}
                                </option>
                              );
                          })}
                        </select>
                      </div>
                    )}
                    {/*Organizations*/}
                    <div className="field-wrapper">
                      <label htmlFor="organization" className="sp-margin3">
                        Organization
                      </label>
                      {/*<i className="bi bi-asterisk rd-clr"></i>*/}
                      <span className="filter-container dg-clr">
                        <input
                          className="form-control filter-sm"
                          type="search"
                          placeholder="Filter"
                          id="organizationFilter"
                          name="OrganizationFilter"
                          aria-label="Filter Organizations"
                          onChange={(el) => filterOrgs(el.target.value)}
                        />
                      </span>
                      <select
                        className="form-control"
                        size="4"
                        id="organization"
                        name="Organization"
                        aria-label="Select Organization"
                        onChange={(el) => {
                          if (el.target.value !== "") {
                            SelectUsersByOrgIdSearch(el.target.value);
                          }
                        }}
                        value={customerOrgValSearch}
                      >
                        {orgObjSearch.length === 0 ? (
                          <option value="" disabled>No Results</option>
                        ) : (
                          <>
                            <option value="">Select Organization</option>
                            {orgObjSearch.map((el) => {
                              if (el.show)
                                return (
                                  <option key={el.id} value={el.id}>
                                    {el.name}
                                  </option>
                                );
                            })}
                          </>
                        )}
                      </select>
                      {!customerOrgValSearch && submitFlag ? (
                        <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Organization is Required!
                        </div>
                      ) : null}
                    </div>

                    {/*Email*/}
                    <div className="field-wrapper">
                      <label htmlFor="email">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="Email"
                        onChange={(el) => setAnswer("Email", el.target.value)}
                        value={answers?.Email}
                        aria-label="Enter Direct Email"
                        placeholder="Enter Direct Email"
                      />
                    </div>
                    <div className="field-wrapper">
                      {/* From Date*/}
                      <div className="spacer-margin5 spacer-inline w-md2">
                        <label htmlFor="fromDateInput">From Date</label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          // data-date-start-date="-7d"
                          data-date-end-date="0d"
                          onChange={(el) =>
                            setAnswer("FromDate", el.target.value)
                          }
                          value={answers?.FromDate}
                          data-date={answers?.FromDate}
                          aria-label="Select From Date"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="fromDateInput"
                            id="fromDateInput"
                            aria-label="Enter From Date"
                            onChange={(el) => handleDateChange("FromDate", el.target.value)}
                            value={answers?.FromDate ?? ""}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">
                              <i className="fas fa-calendar" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* To Date*/}
                      <div className="spacer-inline w-md2">
                        <label htmlFor="toDateInput">To Date</label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          // data-date-start-date="-7d"
                          data-date-end-date="0d"
                          aria-label="Select To Date"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="ToDate"
                            id="toDateInput"
                            onChange={(el) => {
                              handleDateChange("ToDate", el.target.value);
                            }}
                            value={answers?.ToDate ?? ""}
                            aria-label="Enter To Date"
                          />
                          <div className="input-group-append">
                            <span className="input-group-text" >
                              <i className="fas fa-calendar" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                      </div>

                    </div>

                    {/*First or Last Name*/}
                    <div className="field-wrapper">
                      <label htmlFor="name">Member Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Name"
                        id="name"
                        onChange={(el) => setAnswer("Name", el.target.value)}
                        value={answers?.Name}
                        aria-label="Enter Name"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => AdvSearch()}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={CloseAdvSearch}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
          {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="search-loader-id"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="search-loader-id">{loadingText}</div>
            </div>
          )}
        </div>
      </div>
      <UserEmailList emailListObj={emailListObj} />
      <DetailsOrgEmails
        detailsEmail={detailsEmail}
        emailRefresh={emailRefresh}
      />
    </main>
  );
};

export default ListEmails;
